import { keyframes } from "@mui/system";

const scrollAnimation = keyframes`
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
`;

export const downTime = {
    banner: {
        backgroundColor: "red",
        color: "white",
        fontSize: "1.2rem",
        fontWeight: "bold",
        width: "100%",
        overflow: "hidden",
        whiteSpace: "nowrap",
        position: "fixed",
        bottom: 0,
        left: 0,
        zIndex: 1000,
    },
    scrollText: {
        display: "inline-block",
        paddingLeft: "10%",
        animation: `${scrollAnimation} 30s linear infinite`,
    }
} as const;
